var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 62,
    viewBox: "0 0 52 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 31C52.0019 31.8096 51.7962 32.606 51.4027 33.3116C51.0092 34.0172 50.4414 34.6081 49.7545 35.0268L7.18545 61.2981C6.46775 61.7414 5.64574 61.9835 4.80432 61.9992C3.9629 62.0149 3.13257 61.8037 2.39909 61.3875C1.6726 60.9777 1.06741 60.3801 0.645757 59.6561C0.224106 58.9322 0.0012139 58.1079 0 57.2683V4.73174C0.0012139 3.89205 0.224106 3.06785 0.645757 2.34388C1.06741 1.6199 1.6726 1.0223 2.39909 0.612516C3.13257 0.196267 3.9629 -0.0149017 4.80432 0.000817724C5.64574 0.0165372 6.46775 0.258576 7.18545 0.701935L49.7545 26.9732C50.4414 27.3919 51.0092 27.9828 51.4027 28.6884C51.7962 29.394 52.0019 30.1904 52 31Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.90edd62d8efdbcd1eb6f92bc4582f0c3.svg";
export { ForwardRef as ReactComponent };